export const loadTrustpilot = (ref: any) => {
  // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
  // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
  // When it is, it will automatically load the TrustBox.
  const trustpilot = (<any>window).Trustpilot;
  if (trustpilot) {
    trustpilot.loadFromElement(ref, true);
  }
}